require('./angular-sql-storage');
module.exports = 'sf.sqlStorage';
